import React, { Fragment, useState, useEffect, useRef } from "react";
import { Row, Col, Form, Button, DatePicker, Select, Image } from "antd";

import { useNavigate, useParams } from "react-router-dom";
import { fallbackcover } from "../../../common/Utils";

import Swal from "sweetalert2";
import { serverError } from "../../../common/Alerts/serverError";
import { CreateProfileOrganizerAPI } from "../../../Config/API/organizer";
import { useFetchInitialProfile } from "../../../common/hooks/useFetchInitialProfile";

import Loader from "../../../common/cards/Loader";
import { error, success } from "../../../common/Alerts/Message";
// import ExperienceModal from "../../../common/Model/ExperienceModal";
// import { IoAddSharp } from "react-icons/io5";
// import useFieldsVaildator from "../../../common/hooks/useFieldsVaildator";
import { Formik } from "formik";
import InputTextField from "../../../common/FormItem/InputTextField";
import dayjs from "dayjs";
import { createPlayerOrganizerValidations } from "../../../Config/helpers/validations";
import { LOCATIONS, ROLES } from "../../../Config/helpers/constants";
import UserNameField from "../../../common/FormItem/UserNameField";
import useEditProfile from "../../../common/hooks/useEditProfile";
import { useFetchProfile } from "../../../common/hooks/useFetchProfile";
import { useSelector } from "react-redux";
import { PROFILE } from "../../../Store/Features/ProfileSlice";
import moment from "moment";
import { KEYS } from "../../../Config/Keys";
import { ImageUploader } from "../Event/Components/ImageUploader";

const { Option } = Select;

const CreateOrganizerProfile = () => {
  const { id } = useParams();
  const [editloading, edit] = useEditProfile();
  let profileData, profileDataLoading, setProfileDataLoading;
  if (!id) {
    // if creating profile fetch initial profile data
    const { Profile, profileLoding, setprofileLoding } = useFetchInitialProfile(ROLES.organizer);

    profileData = Profile;
    profileDataLoading = profileLoding;
    setProfileDataLoading = setprofileLoding;
  } else {
    // if editing profile
    const { profileLoding } = useFetchProfile(id, ROLES.organizer);
    const Profile = useSelector(PROFILE);
    profileData = Profile;
    profileDataLoading = profileLoding;
  }

  // const { inputTextVaildator, imageFileValidator } = useFieldsVaildator();

  // Profile
  const [profileImage, setProfileImage] = useState({
    file: {},
    preview: ""
  });

  const [coverImage, setCoverImage] = useState({
    file: {},
    preview: ""
  });

  const [imagesDirty, setImagesDirty] = useState(false);

  const initialValues = {
    firstName: profileData?.firstName || "",
    lastName: profileData?.lastName || "",
    name: id ? profileData?.name : "",
    username: id ? profileData?.username || "" : profileData?.username || "",
    location: id ? profileData?.location || "" : "",
    DOB: profileData?.dob || "",
    description: id ? profileData?.description || "" : ""
    // awards: "",
    // endorsements: "",
    // experience: {
    //   name: "",
    //   date: "",
    //   location: "",
    //   panelName: "",
    //   role: "",
    //   awards: "",
    //   description: "",
    //   pictures: ""
    // }
  };

  useEffect(() => {
    if (id) {
      setCoverImage({
        file: {},
        preview: KEYS.API + "/" + profileData.cover
      });
      setProfileImage({
        file: {},
        preview: KEYS.API + "/" + profileData.profile
      });
    }

    return () => {
      setCoverImage({
        file: null,
        preview: ""
      });
      setProfileImage({
        file: null,
        preview: ""
      });
    };
  }, [profileData]);

  const children = [];
  for (let i = 10; i < 36; i++) {
    children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
  }
  const navigate = useNavigate();

  const isProfile = useRef();
  const isCover = useRef();
  // input type image handler
  const onImageFileChange = async (e) => {
    const file = e.target.files[0];
    if (file?.size > 5000000) {
      return Swal.fire({
        icon: "error",
        title: "Uploading Error",
        text: "Image size should be less than 5mb",
        confirmButtonColor: "#0085FF",
        allowOutsideClick: false
      });
    }
    if (file) {
      if (e.target.name === "profileImage") {
        isProfile.current = true;
        setProfileImage({
          file: file,
          preview: URL.createObjectURL(file)
        });
      } else {
        isCover.current = true;
        setCoverImage({
          file: file,
          preview: URL.createObjectURL(file)
        });
      }
      setImagesDirty(true);
    }
  };

  const onFinish = async (values) => {
    if (profileImage?.preview === "") {
      return Swal.fire({
        icon: "error",
        title: "Upload profile photo first"
      });
    }

    const formData = new FormData();

    if (id) {
      formData.append("name", values?.name);
    } else {
      formData.append("name", values?.firstName + " " + values?.lastName);
    }

    if (profileData?.username !== values?.username) {
      formData.append("username", values?.username || "");
    }
    formData.append("dob", JSON.stringify(dayjs(values?.DOB).format("YYYY-MM-DD")) || "");
    formData.append("awards", values?.awards?.toString() || "");
    formData.append("location", values?.location || "");

    formData.append("description", values?.description || "");
    if (profileImage?.preview && isProfile.current === true) {
      formData.append("profile", profileImage?.file);
    }
    if (coverImage?.preview && isCover.current === true) {
      formData.append("cover", coverImage?.file);
    }
    let response;
    if (id) {
      try {
        formData.append("id", id);
        edit(formData, ROLES.organizer, id);
      } catch (e) {
        error(e.message);
        Swal.fire({
          icon: "error",
          text: e.message
        });
      }
    } else {
      try {
        setProfileDataLoading(true);
        response = await CreateProfileOrganizerAPI(formData);
        const data = await response.json();
        setProfileDataLoading(false);
        if (data.type === "success") {
          success("Profile Created Succesfully");
          navigate("/organizer/feed");
        }

        if (data?.type === "failure") {
          error(data?.result);
        }
      } catch (err) {
        console.log(err);
        setProfileDataLoading(false);

        serverError();
      }
    }
  };

  // handle non-formik field changes
  function handleChanges(name, value, setFieldValue) {
    setFieldValue(name, value);
  }
  return (
    <Fragment>
      <div className="profileContainer">
        {profileDataLoading && <Loader fullpage loading={"white"} />}
        <Row>
          <Col sm={24} xs={24} md={24} style={{ position: "relative" }}>
            <div
              style={{
                position: "relative",
                width: "96%",
                margin: "auto",
                background: "#DADADA",
                borderRadius: "8px"
              }}
              className="CoverImageWrapper">
              {coverImage?.preview !== "" ? (
                <Image
                  wrapperClassName="CoverImageWrapper"
                  className="CoverImage"
                  preview={false}
                  src={coverImage?.preview}
                  style={{ objectFit: "contain" }}
                  fallback={fallbackcover}
                />
              ) : null}
              <ImageUploader
                name="CoverImage"
                id="coveruploader"
                imageType="profileCover"
                onChange={onImageFileChange}>
                <div className="profileuploaders">
                  <label htmlFor="coveruploader" style={{}}>
                    <img src="/images/icons/camera.png" alt="" />
                    {coverImage?.preview === "" ? <span>Add your Cover image</span> : null}
                  </label>
                  {/* <input
                    type="file"
                    name="CoverImage"
                    className="uploaderInput"
                    id="coveruploader"
                    accept="image/*"
                    onChange={onImageFileChange}
                  /> */}
                </div>
              </ImageUploader>
            </div>
            <div className="profileuploaderForProfile">
              {profileImage?.preview !== "" ? (
                <Image
                  preview={false}
                  wrapperClassName="profileImageWrapper"
                  className="ProfileImage"
                  style={{ objectFit: "contain" }}
                  src={profileImage?.preview}
                  fallback={fallbackcover}
                />
              ) : null}
              <ImageUploader
                name="profileImage"
                id="profileuploader"
                imageType="profile"
                round
                onChange={onImageFileChange}>
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    top: 0,
                    left: 0
                  }}>
                  <label htmlFor="profileuploader">
                    <img src="/images/icons/camerasmall.png" alt="" />
                    {profileImage?.preview === "" ? <span>Add Profile</span> : null}
                  </label>
                  {/* <input
                  type="file"
                  name="profileImage"
                  className="uploaderInput"
                  id="profileuploader"
                  accept="image/*"
                  onChange={onImageFileChange}
                /> */}
                </div>
              </ImageUploader>
            </div>
          </Col>
        </Row>
        <div className="formorganizer">
          <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={onFinish}
            validationSchema={createPlayerOrganizerValidations(id ? true : false)}>
            {({ errors, values, setFieldValue, handleSubmit, isValid, dirty }) => (
              <Form
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                autoComplete="off"
                onFinish={handleSubmit}>
                <Row justify="space-between">
                  <Col lg={12} md={12} xs={24} sm={24} className="ceinputformpadding">
                    {/* FirstName */}
                    <InputTextField
                      name="firstName"
                      className="customfield"
                      required
                      label="First Name"
                      placeholder="Enter your first name"
                    />
                    {/* LastName */}
                    <InputTextField
                      name="lastName"
                      className="customfield"
                      required
                      label="Last Name"
                      placeholder="Enter your last name"
                    />

                    {/* date */}
                    <Form.Item
                      className="customfield"
                      required
                      label="Date of Birth"
                      help={errors?.DOB ? errors?.DOB : undefined}
                      validateStatus={errors?.DOB ? "error" : "success"}>
                      <DatePicker
                        value={values?.DOB ? moment(values?.DOB) : undefined}
                        className="playerDob"
                        name="DOB"
                        showToday
                        inputReadOnly
                        onChange={(value) => handleChanges("DOB", value, setFieldValue)}
                      />
                    </Form.Item>
                    {/* location */}
                    <Form.Item
                      required
                      label="Location"
                      help={errors?.location ? errors?.location : undefined}
                      validateStatus={errors?.location ? "error" : "success"}>
                      <Select
                        className="mb-2 w-100"
                        aria-required
                        value={values?.location}
                        placeholder="Location"
                        title="Location"
                        bordered={true}
                        name="location"
                        onChange={(value) => setFieldValue("location", value)}>
                        {LOCATIONS.map((item, index) => (
                          <Option key={index} value={item.value}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={12} xs={24} sm={24} className="ceinputformpadding">
                    {/* USERNAME */}
                    <UserNameField
                      className="customfield"
                      error={errors?.username}
                      value={values?.username}
                      setFieldValue={setFieldValue}
                      type={ROLES.organizer}
                      prevUserName={id ? profileData?.username || "" : ""} //incase of edit
                    />
                    <InputTextField
                      className="customfield"
                      name="description"
                      label="Organizer’s Bio"
                      placeholder="Something about yourself..."
                      type="textArea"
                    />
                  </Col>
                </Row>

                <Row justify="center">
                  <Button
                    loading={editloading}
                    htmlType="submit"
                    disabled={!(isValid && (dirty || imagesDirty)) || editloading}
                    className="playerCreateBUtton"
                    type="primary">
                    {id ? "Edit" : "Create"}
                  </Button>
                </Row>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Fragment>
  );
};

export default CreateOrganizerProfile;
